module.exports = __webpack_public_path__ + "static/media/4.a31618e0.png";